<template>
  <div class="field">
    <label class="label"
      >{{ props.field.properties.label }}
      <v-btn
        v-if="props.field.tooltip"
        v-tooltip:right="props.field.tooltip"
        icon="fa-info-circle"
        variant="text"
      />
    </label>
    <v-sheet expanded>
      {{ props.field.properties.text }}
    </v-sheet>
  </div>
</template>

<script setup lang="ts">
import type { SchemaFormKitProps } from './types'

const props = defineProps<SchemaFormKitProps>()
</script>
